import React from "react";
import './FameWall.css';

function FameWall() {
    return (
        <>
            <div className="champions-container">
                <h2>Fame Wall: Honoring Our Champions!</h2>
                <div class="border-gradient horizontal-underline only-top"></div>
                <div className="champions-wrap">
                    <div className="champions-row row1">
                        <div className="champions-box box1">
                            <img src="/images/DashboardNew/Ribbon.png" alt="ribbon" className="ribbon-img" />
                            <img src="/images/DashboardNew/French.png" alt="french-flag" className="lang-flag" />
                            <h5 className="card-heading">French</h5>
                            <div className="badge-container">
                                <img src="/images/DashboardNew/Badge.png" alt="badge" className=" badge-img" />
                                <img src="/images/DashboardNew/Badge.png" alt="badge" className=" badge-img" />
                                <div className="internal-content">Internal <br />Certified <br /><span>449</span></div>
                                <div className="external-content">External <br />Certified <br /><span>107</span></div>
                            </div>
                        </div>
                        <div className="champions-box box2">
                            <img src="/images/DashboardNew/Ribbon.png" alt="ribbon" className="ribbon-img" />
                            <img src="/images/DashboardNew/German.png" alt="german-flag" className="lang-flag" />
                            <h5 className="card-heading">German</h5>
                            <div className="badge-container">
                                <img src="/images/DashboardNew/Badge.png" alt="badge" className=" badge-img" />
                                <img src="/images/DashboardNew/Badge.png" alt="badge" className=" badge-img" />
                                <div className="internal-content">Internal <br />Certified <br /><span>1185</span></div>
                                <div className="external-content">External <br />Certified <br /><span>38</span></div>
                            </div>
                        </div>
                    </div>
                    <div className="champions-row row2">
                        <div className="champions-box box3">
                            <img src="/images/DashboardNew/Ribbon.png" alt="ribbon" className="ribbon-img" />
                            <h5 className="card-heading overall">Overall</h5>
                            <div className="badge-container middle">
                                <img src="/images/DashboardNew/Overall-badge.png" alt="overall-badge" className="overall-badge" />
                                <img src="/images/DashboardNew/Overall-badge.png" alt="overall-badge" className="overall-badge" />
                                <div className="internal-content overall">Internal <br />Certified <br /><span>2370</span></div>
                                <div className="external-content overall">External <br />Certified <br /><span>305</span></div>
                            </div>
                        </div>
                    </div>
                    <div className="champions-row row3">
                        <div className="champions-box box4">
                            <img src="/images/DashboardNew/Ribbon.png" alt="ribbon" className="ribbon-img" />
                            <img src="/images/DashboardNew/Spanish.png" alt="spanish-flag" className="lang-flag" />
                            <h5 className="card-heading">Spanish</h5>
                            <div className="badge-container">
                                <img src="/images/DashboardNew/Badge.png" alt="badge" className=" badge-img" />
                                <img src="/images/DashboardNew/Badge.png" alt="badge" className=" badge-img" />
                                <div className="internal-content">Internal <br />Certified <br /><span>406</span></div>
                                <div className="external-content">External <br />Certified <br /><span>8</span></div>
                            </div>
                        </div>
                        <div className="champions-box box5">
                            <img src="/images/DashboardNew/Ribbon.png" alt="ribbon" className="ribbon-img" />
                            <img src="/images/DashboardNew/italian.png" alt="italian-flag" className="lang-flag" />
                            <h5 className="card-heading">Italian</h5>
                            <div className="badge-container">
                                <img src="/images/DashboardNew/Badge.png" alt="badge" className=" badge-img" />
                                <img src="/images/DashboardNew/Badge.png" alt="badge" className=" badge-img" />
                                <div className="internal-content">Internal <br />Certified <br /><span>288</span></div>
                                <div className="external-content">External <br />Certified <br /><span>14</span></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default FameWall;
